module.exports = __webpack_public_path__ + "4413ecb7.svg";